import { get } from "./apiClient";

export default {
  async list() {
    return await get(`Countries`);
  }
};
